export const editCanvasModal = {
  extends: '/add-canvas-modal',
  ModalHeader: {
    title: 'Edit {{ title }} canvas',
    p: 'Edit custom canvas page'
  },
  Flex: {
    InputField: {
      pointerEvents: 'none',
      Input: {
        opacity: '.65',
        disabled: 'disabled'
      }
    }
  },
  ModalFooter: {
    CheckButton: {
      minHeight: 'controlH',
      padding: '0 A',
      fontSize: 'Z2'
    },
    IconButton: {
      icon: 'trash outline',
      onClick: async (ev, el, s) => {
        await el.call('deleteCanvasPage', s.key)
      }
    }
  },
  onInit: async (el, s) => {
    const key = s.key || el.call('getLastLocationPath').slice(1)
    await s.quietReplace(canvasPageData)
  },
  onSubmit: async (e, el, s, ctx) => {
    e.preventDefault()
    await el.call('addCanvasPage', s, {
      preventNameCheck: true
    })
    await el.call('closeRouterModal')
  }
}
